import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

export type UiState = {
  sideMenuOpen: boolean;
  settingSideSubMenuOpen: boolean;
  orgSideSubMenuOpen: boolean;
};

export const initialUiState: UiState = {
  sideMenuOpen: false,
  settingSideSubMenuOpen: false,
  orgSideSubMenuOpen: false
};

const uiSlice = createSlice({
  name: "ui",
  initialState: initialUiState,
  reducers: {
    sideMenuToggled: (state) => {
      state.sideMenuOpen = !state.sideMenuOpen;
    },
    sideMenuSet: (state, action: PayloadAction<boolean>) => {
      state.sideMenuOpen = action.payload;
    },
    settingSideSubMenuToggled: (state) => {
      state.settingSideSubMenuOpen = !state.settingSideSubMenuOpen;
    },
    settingSideSubMenuSet: (state, action: PayloadAction<boolean>) => {
      state.settingSideSubMenuOpen = action.payload;
    },
    orgSideSubMenuToggled: (state) => {
      state.orgSideSubMenuOpen = !state.orgSideSubMenuOpen;
    },
    orgSideSubMenuSet: (state, action: PayloadAction<boolean>) => {
      state.orgSideSubMenuOpen = action.payload;
    }
  }
});

export const {
  sideMenuToggled,
  sideMenuSet,
  settingSideSubMenuToggled,
  settingSideSubMenuSet,
  orgSideSubMenuToggled,
  orgSideSubMenuSet
} = uiSlice.actions;

export const selectSideMenuOpen = (state: RootState): boolean =>
  state.ui.sideMenuOpen;
export const selectSettingSideSubMenuOpen = (state: RootState): boolean =>
  state.ui.settingSideSubMenuOpen;
export const selectOrgSideSubMenuOpen = (state: RootState): boolean =>
  state.ui.orgSideSubMenuOpen;

export const uiReducer = uiSlice.reducer;
export default uiReducer;
